module.exports = __webpack_public_path__ + "media/images/room_menu_icon/machine_error_histories-0d56d8b16e902e3e9bf570525b866b34.png";